module.exports = {"id":"231949","name":"Saman Ghoddos","rating":"72","photo":"./data/images/photos/2/231949.png","club":{"name":"Östersunds FK","logo":"./data/images/clubs/OstersundsFK.png"},"positions":["BU"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SamanGhoddos0.json
// module id = 3792
// module chunks = 0